module.exports = __webpack_public_path__ + "img/logo_comparte.25345e9d.svg";